import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentInit,
  AfterViewInit,
  HostListener,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import $ from 'jquery';
import { CodeService, AuthService, BUYER_ROLE, BUYER_STATUS } from '../../../shared';
import { Tree } from '../../../../app/common/libs';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  PopularSearch,
  SearchDto,
  DisplayCategory,
  HomeDto,
  NoticeBoard,
  NoticeBoardListDto,
  Buyer,
  Product,
} from '../../../dto';
import { SearchService, HomeService, ProductService, BuyerService, GaService, SearchResultType } from '../../../services';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized, NavigationExtras } from '@angular/router';
import { BaseUser } from '../../../shared/auth/dto/base-user';
import { BaseComponent, ERROR_TYPE, ErrorResponse } from '../../../core';
import { debounceTime, distinctUntilChanged, filter, pairwise, takeWhile } from 'rxjs/operators';
import dayjs from 'dayjs';
import Swiper from 'swiper';
import { UDirectService } from 'src/app/services/udirect.service';
// import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
// import { CookieService } from 'ngx-cookie';
export {};
declare global {
  interface Window {
    Calendly: any;
  }
}

enum HEADER {
  AUTHORIZED = 'AUTHORIZED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NONE = 'none',
}

enum FOOTER {
  AUTHORIZED = 'AUTHORIZED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NONE = 'none',
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent extends BaseComponent implements OnInit, AfterViewInit {
  private el = inject(ElementRef);
  private codeService = inject(CodeService);
  private formBuilder = inject(FormBuilder);
  private searchService = inject(SearchService);
  private homeService = inject(HomeService);
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private productService = inject(ProductService);
  private gaService = inject(GaService);
  private cdr = inject(ChangeDetectorRef);
  uDirectService = inject(UDirectService);

  static UNAUTHORIZED_LAYOUT = {
    header: HEADER.UNAUTHORIZED,
    footer: FOOTER.UNAUTHORIZED,
  };

  static AUTHORIZED_LAYOUT = {
    header: HEADER.AUTHORIZED,
    footer: FOOTER.AUTHORIZED,
  };

  static AUTHORIZED_WITHOUT_FOOTER_LAYOUT = {
    header: HEADER.AUTHORIZED,
    footer: FOOTER.NONE,
  };

  SEARCH_TYPE = Object.freeze({
    BRAND: 'BRAND',
    PRODUCT: 'PRODUCT',
    SEARCH: 'SEARCH',
  });

  SEARCH_URL = '/search?q=';

  lang = this.LANGUAGES[0];
  // googleLanguage = this.GOOGLE_LANGUAGES[0];

  isNotChrome = false;
  noticeBoards: NoticeBoard[] = [];

  displayCategory: DisplayCategory[];
  displayCategoryTree: Tree<DisplayCategory>;
  searchForm: FormGroup;
  recentSearches: Array<string> = [];
  popularSearches: PopularSearch[];
  isSearchingLists: SearchDto[];
  brandsType: SearchDto[] = [];
  productType: SearchDto[] = [];
  isSearching = false;
  defaultSearch = false;
  user: BaseUser;
  isDisableNext = false; // true: 비활성화, false: 활성화
  private isErrorDialogOpen = false;
  isDisablePrev = true; // true: 비활성화, false: 활성화

  header: HEADER = LayoutComponent.UNAUTHORIZED_LAYOUT.header;
  footer: FOOTER = LayoutComponent.UNAUTHORIZED_LAYOUT.footer;

  visualNoticeConfig: Swiper;

  @ViewChild('Keyword', { read: ElementRef, static: false })
  Keyword: ElementRef;
  @ViewChild('authorizedHeaderTop', { read: ElementRef, static: false })
  authorizedHeaderTop: ElementRef;
  @ViewChild('headerRef', { read: ElementRef, static: false })
  headerRef: ElementRef;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.header === 'UNAUTHORIZED') {
      return;
    }

    this.headerRef.nativeElement.classList.add('active');
    // const headerOffset = this.authorizedHeaderTop.nativeElement.offsetHeight;
    // if (window.pageYOffset >= headerOffset) {
    //   // $('header').addClass('active');
    //   this.headerRef.nativeElement.classList.add('active');
    // } else {
    //   // $('header').removeClass('active');
    //   this.headerRef.nativeElement.classList.remove('active');
    // }
  }

  ngOnInit() {
    // window.Calendly.initBadgeWidget({
    //   url: 'https://calendly.com/umma_craver',
    //   text: 'schedule a meeting',
    //   color: '#f23da6',
    //   textColor: '#ffffff',
    //   branding: false,
    // });
    // let t: any = document.querySelectorAll('.calendly-badge-widget')[0];
    // if (this.userDeviceInfo === 'pc') {
    //   t.classList.add('pc');
    // } else {
    //   t.classList.remove('pc');
    // }
    this.searchForm = this.formBuilder.group({
      keyword: [''],
    });

    this.router.events.pipe(takeWhile(() => this.isAlive)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.startsWith(this.SEARCH_URL)) {
          this.searchForm.get('keyword').setValue(decodeURIComponent(this.router.url.replace(this.SEARCH_URL, '')));
        }
      }
    });

    this.route.data.pipe(takeWhile(() => this.isAlive)).subscribe((data) => {
      this.user = this.authService.getUser();
      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.DORMANT) ||
          this.user.buyerStatus.includes(BUYER_STATUS.REACTIVATE))
      ) {
        this.router.navigate(['/signin/dormant']);
      }
      // if (this.user && !this.user.isCertified) {
      //   this.router.navigate(['/signin/mobile-otp']);
      // }
      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.WAITING) || this.user.buyerStatus.includes(BUYER_STATUS.REVIEWED))
      ) {
        this.router.navigate(['/signin/waiting']);
      }

      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.REFUSED) || this.user.buyerStatus.includes(BUYER_STATUS.REREQUEST))
      ) {
        this.router.navigate(['/my/account']);
      }
      if (this.user && this.user.userRoles.includes(BUYER_ROLE.BUYER_APPROVED) && data.layout) {
        this.homeService.getNotice(this.i18n.language).subscribe((NoticeBoards) => {
          this.noticeBoards = NoticeBoards;
          this.cdr.detectChanges();
          this.visualNoticeConfig = new Swiper('.visualNoticeConfig', {
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
            },
            loop: true,
            direction: 'vertical',
            threshold: 2,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
              nextEl: '.button-next-notice',
              prevEl: '.button-prev-notice',
            },
          });
        });
        this.header = data.layout.header || this.header;
        this.footer = data.layout.footer || this.footer;
      }
    });
    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        const previousUrl = e[0].urlAfterRedirects;
        if (previousUrl.indexOf('/withdraw') === 0) {
          this.router.navigate(['/withdraw']);
        }
        // if (
        //   this.user &&
        //   (!previousUrl || previousUrl.indexOf('/withdraw') < 0) &&
        //   (this.user.buyerStatus.includes(BUYER_STATUS.REFUSED) ||
        //     this.user.buyerStatus.includes(BUYER_STATUS.REREQUEST))
        // ) {
        //   this.router.navigate(['/my/account']);
        // }
      });
    this.LANGUAGES.forEach((lang) => {
      if (lang.locale === this.i18n.language) {
        this.lang = lang;
      }
    });

    // this.GOOGLE_LANGUAGES.forEach((lang) => {
    //   const cookieKey = this.cookieService.getObject('googtrans') ? this.cookieService.get('googtrans').split('/')[2] : '';
    //   if (lang.locale === cookieKey) {
    //     this.googleLanguage = lang;
    //   }
    // });

    this.displayCategory = this.homeService.getMainDisplayCategory();

    localStorage.getItem('search')
      ? (this.recentSearches = JSON.parse(localStorage.getItem('search')))
      : localStorage.setItem('search', JSON.stringify([]));

    this.searchForm
      .get('keyword')
      .valueChanges.pipe(takeWhile(() => this.isAlive))
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((keyword) => {
        this.isSearching = (keyword && keyword !== '') || (keyword && keyword.length > 2);
        if (keyword) {
          this.searchService.getSearch(keyword).subscribe(
            (searchDto) => {
              this.isSearchingLists = searchDto;

              this.brandsType = this.isSearchingLists.filter((list) => list.searchType.includes('BRAND'));
              this.productType = this.isSearchingLists.filter((list) => list.searchType.includes('PRODUCT'));

              this.sendKeywordToGA(keyword, this.brandsType, this.productType);
            },
            (error: ErrorResponse) => {
              if (error.type === ERROR_TYPE.VALIDATOR && error.errors && error.errors['keyword']) {
                const field = error.errors['keyword'];
                if (field.message && field.message.toLowerCase().includes('shorter than or equal to')) {
                  // 이미 에러 다이얼로그가 열려있으면 무시
                  if (this.isErrorDialogOpen) {
                    return;
                  }

                  this.isErrorDialogOpen = true;
                  const dialog = this._openDialog({
                    message: field.message || 'keyword must be shorter than or equal to 128 characters',
                    close: () => {
                      const currentValue = this.searchForm.get('keyword').value;
                      if (currentValue && currentValue.length > 100) {
                        this.searchForm.get('keyword').setValue(currentValue.substring(0, 100));
                      }
                      this.isErrorDialogOpen = false;
                      dialog.close();
                    },
                  });
                }
                return;
              }
              console.error('Search error', error);
            }
          );
        } else {
          this.brandsType = [];
          this.productType = [];
        }
      });

    this.searchService.getPopularSearch().subscribe((popularSearches) => {
      this.popularSearches = popularSearches;
    });

    this.displayCategoryTree = this.codeService.getDisplayCategoryAsTree();
    this.unsupportedFunction();
  }

  // ngAfterContentInit() {
  //   this.ui_actions();
  // }

  ngAfterViewInit() {
    this.ui_actions();
  }

  goCategory(categoryId: number) {
    this.router.navigate(['/category', categoryId], { queryParams: { categoryId } });
  }

  onSearch(header?: HTMLElement, searchLabel?: HTMLElement) {
    // small search 돋보기 선택일시 검색안하고 toggle
    if (header && header.classList.contains('active') && !searchLabel.classList.contains('active')) {
      return searchLabel.classList.toggle('active');
    }

    const keyword = this.searchForm.get('keyword').value;
    const isInclude = this.recentSearches.includes(keyword);
    if (keyword) {
      this.router.navigate([`/search`], { queryParams: { q: keyword } });

      this.defaultSearch = false;
      this.isSearching = false;
      if (this.recentSearches.length < 10 && !isInclude) {
        this.recentSearches.unshift(keyword);
      } else if (!isInclude) {
        this.recentSearches.pop();
        this.recentSearches.unshift(keyword);
      }
      localStorage.setItem('search', JSON.stringify(this.recentSearches));
    } else {
      const dialog = this._openDialog({
        message: this.i18n.t('DIALOG.SEARCH.REQUIRED'),
        close: () => {
          dialog.close();
        },
      });
    }

    this.Keyword.nativeElement.blur();
  }

  openDefaultSearch() {
    this.defaultSearch = true;
    this.gaService.logSearchBarOpen();
  }

  onClickKeyword(
    searchType: string,
    keyword: number | string,
    isTrend?: boolean,
    product?: SearchDto['item'],
    index = 0
  ) {
    this.defaultSearch = false;
    this.isSearching = false;
    switch (searchType) {
      case this.SEARCH_TYPE.BRAND:
        this.searchForm.get('keyword').setValue('');
        this.router.navigate([`/brand`, keyword], { queryParams: { brandId: keyword } });
        break;
      case this.SEARCH_TYPE.PRODUCT:
        if (product && 'englishName' in product) {
          this.gaService.logSelectItemFromSearch(product as Product, index);
        }
        this.searchForm.get('keyword').setValue('');
        this.router.navigate([`/product`, keyword], {
          queryParams: { productId: keyword, list: 'search' },
        });
        break;
      case this.SEARCH_TYPE.SEARCH:
        this.router.navigate([`/search`], { queryParams: { q: keyword } });
        if (isTrend) {
          this.gaService.logClickSearchSuggestion(`${keyword}`);
        }
        break;
    }
  }

  onRemoveItems(event: Event, i: number) {
    this.recentSearches.splice(i, 1);
    localStorage.setItem('search', JSON.stringify(this.recentSearches));
  }

  clearAllItems() {
    const dialog = this._openDialog({
      message: this.i18n.t('DIALOG.SEARCH.DELETE'),
      close: () => {
        localStorage.removeItem('search');
        this.recentSearches = [];
        dialog.close();
      },
      cancel: () => {
        dialog.close();
      },
    });
  }

  sendKeywordToGA(keyword: string, brandsType: SearchDto[], productType: SearchDto[]) {
    const hasBrand = brandsType.length > 0;
    const hasProduct = productType.length > 0;
    let resultType: SearchResultType;
    if (!hasBrand && !hasProduct) {
      resultType = 'brand-product-not-found';
    } else if (hasBrand && !hasProduct) {
      resultType = 'brand-only-found';
    } else if (!hasBrand && hasProduct) {
      resultType = 'product-only-found';
    } else {
      resultType = 'brand-product-found';
    }

    this.gaService.logSearch(keyword, resultType, brandsType.length, productType.length);
  }

  private ui_actions() {
    // tslint:disable-next-line: deprecation
    $(document).ready(() => {
      gnbAction();
    });
    const gnbAction = () => {
      const gnb = $('.gnb');
      const gnbList = $('.gnb-link > ul');
      const snb = $('.group-snb');
      const nonCategoryLinks = $('.gnb-second, .right-area');
      let idx;
      // tslint:disable-next-line: prefer-const
      let timeout;
      let clicked = false;

      const hideSnb = () => {
        clearTimeout(timeout);
        gnbList.find('li').removeClass('active');
        snb.hide();
        $('.dim').hide();
      };

      const showSnb = () => {
        clearTimeout(timeout);
        snb.show();
        $('.dim').show();
      };

      gnbList.find('li').on('mouseout', function () {
        if (clicked === true && $(this).hasClass('active')) {
          setTimeout(() => {
            clicked = false;
          }, 100);
        }
      });
      gnbList.find('li').on('mouseover', function () {
        if (clicked === true && $(this).hasClass('active')) {
          return;
        } else {
          clicked = false;
        }
        if ($(this).index() >= 0) {
          idx = $(this).index();
        }

        clearTimeout(timeout);
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        snb.find('.group-snb-list').hide();
        if (idx >= 0) {
          snb.find('.group-snb-list').eq(idx).show();
        }
        showSnb();
      });

      // 카테고리 L1 / SNB 패널에서만 오픈 (Brand~Direct 핑크 링크는 제외)
      gnbList.on('mouseenter', showSnb);
      snb.on('mouseenter', showSnb);
      // Brand~Direct / Beginner's Guide 호버 시 닫기
      nonCategoryLinks.on('mouseenter', hideSnb);
      // L1 ↔ SNB 이동 시 닫히지 않도록 .gnb 기준으로 leave 처리
      gnb.on('mouseleave', hideSnb);
      // 클릭 시점에는 L1 active가 DOM에 남아 있도록, 메뉴 닫기는 다음 틱으로 지연
      gnb.on('click', 'a', () => {
        clearTimeout(timeout);
        setTimeout(hideSnb, 0);
      });
    };
  }

  unsupportedFunction() {
    if (this.deviceDetector.browser !== 'Chrome') {
      this.isNotChrome = true;
    }
  }

  // onChangeGoogleLanguage(lang: string) {
  //   const dialog = this._openDialog({
  //     message:
  //       'There may be a problem with order payment when changing the language. Please check, change it to English, and proceed again.',
  //     close: () => {
  //       this.GOOGLE_LANGUAGES.forEach((language) => {
  //         if (language.locale === lang) {
  //           this.googleLanguage = language;
  //         }
  //       });
  //       const expiredDate = dayjs().add(7, 'day').toDate();
  //       this.cookieService.put('googtrans', `/en/${lang}`, { expires: expiredDate });
  //       document.location.reload();
  //       dialog.close();
  //     },
  //     cancel: () => {
  //       document.location.reload();
  //       dialog.close();
  //     },
  //   });
  // }

  downloadExcel() {
    this.productService.downloadInventoryExcel();
  }
  goPage(page, i) {
    if (this.noticeBoards[i].noticeCategory === 'APP') {
      window.open(this.noticeBoards[i].content.split('|')[1], '_blank');
    } else {
      this.router.navigate([page]);
    }
  }
}
